/* RESPONSIBLE TEAM: team-fin-qa */
import Model, { attr } from '@ember-data/model';

export default class AiSubtopic extends Model {
  @attr('string') declare name: string;
  @attr('string') declare topicName: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'qa-monitor/ai-subtopic': AiSubtopic;
  }
}
